import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';

import { updateEventRequirements } from '@zero5/garage-api';

import { queryKey as eventsQueryKey } from '@/api/queries/useEventsQuery';

type Response = void;

const useUpdateEventReqMutation = (
  options: UseMutationOptions<Response, Error, {
    eventId: number;
    requiredValetSpaces: number;
    requiredParkingSpaces: number;
    valetPrice: number;
    parkingPrice: number;
  }, string>,
) => {
  const queryClient = useQueryClient();

  return useMutation(
    'updateEventReq',
    async (params) => {
      await updateEventRequirements({
        ...params,
      });

      return;
    },
    {
      ...options,
      onSuccess: (...params) => {
        queryClient.invalidateQueries(eventsQueryKey);
        options?.onSuccess?.(...params);
      },
    },
  );
};
export default useUpdateEventReqMutation;
